export enum AppRoutes {
    ALERT_RULE = '/alert-rules/:id',
    ALERT_RULE_ALERTS = '/alert-rules/:id/alerts',
    ALERT_RULES = '/alert-rules',
    ALERT_RULES_CREATE = '/alert-rules/create',
    ALERT_RULES_EDIT = '/alert-rules/:id/edit',
    ALERTS = '/alerts',
    CAMERAS = '/cameras',
    DATABASE_EVENTS = '/database-events',
    EVENT = '/events/:eventId',
    EVENTS = '/events',
    HOME = '/',
    LOGOUT = '/logout',
    NOT_FOUND = '*',
    PERSON = '/persons/:personId',
    PERSONS = '/persons',
    QUERY_RESULTS = '/explore',
    SETUP_HDMI = '/setuphdmi',
    REPORT = '/reports/:reportId',
    REPORT_EVENT = '/reports/events/:eventId',
    REPORTS = '/reports',
    SETTINGS = '/settings',
    SETTINGS_MEMBER = '/settings/members/:userId',
    SIGN_IN = '/sign-in',
    SOURCE = '/sources/:sourceId',
    SOURCES = '/sources',
    VEHICLE = '/vehicles/:vehicleId',
    VEHICLES = '/vehicles',
}
